import { render } from "./logo-carousel.vue?vue&type=template&id=6839bf02&scoped=true"
import script from "./logo-carousel.vue?vue&type=script&lang=js"
export * from "./logo-carousel.vue?vue&type=script&lang=js"

import "./logo-carousel.vue?vue&type=style&index=0&id=6839bf02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6839bf02"]])

export default __exports__